import React from "react"

import { Button } from "@/components/ui/button"
import { useAuth } from "@/contexts/AuthContext"

/** Shared sign-in/sign-up frame. Google is for HIVED staff; the form is for partner logins. */
const AuthCard: React.FC<{
  title: string
  children: React.ReactNode
}> = ({ title, children }) => {
  const { signInWithGoogle } = useAuth()

  return (
    <div className="flex min-h-[var(--app-vh)] flex-col items-center justify-center bg-gray-50 px-4 py-8">
      <div className="mb-6 flex items-baseline gap-2">
        <span className="text-lg font-semibold text-gray-900">Collections Planning</span>
        <span className="text-sm font-medium text-gray-500">HIVED</span>
      </div>

      <div className="w-full max-w-sm rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-gray-900">{title}</h1>

        <Button variant="outline" className="mt-5 w-full" onClick={() => void signInWithGoogle()}>
          Sign in with Google
        </Button>

        <div className="my-5 flex items-center gap-3 text-xs text-gray-500">
          <span className="h-px flex-1 bg-gray-200" />
          Or
          <span className="h-px flex-1 bg-gray-200" />
        </div>

        {children}
      </div>
    </div>
  )
}

export const StaffEmailNote: React.FC = () => (
  <p role="alert" className="mt-1 text-xs text-amber-700">
    HIVED accounts sign in with Google, above.
  </p>
)

export default AuthCard
